import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import NavbarMobileToggleFab from 'app/fuse-layouts/shared-components/NavbarMobileToggleFab';
import clsx from 'clsx';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { navbarCloseFolded, navbarOpenFolded, navbarCloseMobile } from 'app/store/fuse/navbarSlice';
import { selectNavbarTheme } from 'app/store/fuse/settingsSlice';
import NavbarLayout1 from './NavbarLayout1';
import NavbarHome from './NavbarHome';
import { useLocation } from 'react-router-dom';

const navbarWidth = 280;

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    zIndex: 4,
    [theme.breakpoints.up('lg')]: {
      width: navbarWidth,
      minWidth: navbarWidth
    }
  },
  wrapperFolded: {
    [theme.breakpoints.up('lg')]: {
      width: 64,
      minWidth: 64
    }
  },
  navbar: {
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    flex: '1 1 auto',
    width: navbarWidth,
    minWidth: navbarWidth,
    height: '100%',
    zIndex: 4,
    transition: theme.transitions.create(['width', 'min-width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter
    }),
    boxShadow: theme.shadows[3]
  },
  left: {
    left: 0
  },
  right: {
    right: 0
  },
  folded: {
    position: 'absolute',
    width: 55,
    minWidth: 55,
    top: 0,
    bottom: 0
  },
  foldedAndOpened: {
    width: navbarWidth,
    minWidth: navbarWidth
  },
  navbarContent: {
    flex: '1 1 auto'
  },
  foldedAndClosed: {
    '& $navbarContent': {}
  },
  navbarHomeWrapper: {
    width: '100%',
    position: 'fixed',
    top: 0,
    zIndex: 5,
    backgroundColor: theme.palette.background.default
  }
}));

function NavbarWrapperLayout1(props) {
  const dispatch = useDispatch();
  const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
  const navbarTheme = useSelector(selectNavbarTheme);
  const navbar = useSelector(({ fuse }) => fuse.navbar);
  const location = useLocation();
  const classes = useStyles();

  const { folded } = config.navbar;
  const foldedAndClosed = folded && !navbar.foldedOpen;
  const foldedAndOpened = folded && navbar.foldedOpen;

  const excludeSidebarOnRoutes = [
    '/data-directory/company-profile',
    '/data-directory/lenders',
    '/data-directory/lender/new',
    '/data-directory/lead-sources',
    '/data-directory/lead-source/new',
    '/data-directory/title-companies',
    '/data-directory/title-company/new',
    '/settings/users',
    '/settings/contacts',
    '/settings/agents',
    '/userprofile',
    '/settings/user/new',
    '/settings/contact/new',
    '/pages/errors/error-404',
    '/pages/errors/error-500',
    '/email-templates',
    '/email-templates/new',
    '/form-generator',
    '/form-generator/new'
  ];


  const isExcluded =
    excludeSidebarOnRoutes.includes(location.pathname) ||
    location.pathname.startsWith('/settings/user/') ||
    location.pathname.startsWith('/settings/contact/') ||
    location.pathname.startsWith('/settings/agent/') ||
    location.pathname.startsWith('/data-directory/company-profile/') ||
    location.pathname.startsWith('/data-directory/lead-source/') ||
    location.pathname.startsWith('/data-directory/title-company/') ||
    location.pathname.startsWith('/data-directory/lender/') ||
    location.pathname.startsWith('/email-templates/edit/') ||
    location.pathname.startsWith('/form-generator/edit/');

  if (isExcluded) {
    return (
      <div className={classes.navbarHomeWrapper}>
        <NavbarHome />
      </div>
    );
  }

  return (
    <>
      <div className={classes.navbarHomeWrapper}>
        <NavbarHome />
      </div>

      <ThemeProvider theme={navbarTheme}>
        <div id="fuse-navbar" className={clsx(classes.wrapper, folded && classes.wrapperFolded)}>
          <Hidden mdDown>
            <div
              className={clsx(
                classes.navbar,
                classes[config.navbar.position],
                folded && classes.folded,
                foldedAndOpened && classes.foldedAndOpened,
                foldedAndClosed && classes.foldedAndClosed
              )}
              onMouseEnter={() => foldedAndClosed && dispatch(navbarOpenFolded())}
              onMouseLeave={() => foldedAndOpened && dispatch(navbarCloseFolded())}
              style={{ backgroundColor: navbarTheme.palette.background.default }}
            >
              <NavbarLayout1 className={classes.navbarContent} />
            </div>
          </Hidden>

          <Hidden lgUp>
            <Drawer
              anchor={config.navbar.position}
              variant="temporary"
              open={navbar.mobileOpen}
              classes={{
                paper: classes.navbar
              }}
              onClose={() => dispatch(navbarCloseMobile())}
              ModalProps={{
                keepMounted: true
              }}
            >
              <NavbarLayout1 className={classes.navbarContent} />
            </Drawer>
          </Hidden>
        </div>
      </ThemeProvider>

      {config.navbar.display && !config.toolbar.display && (
        <Hidden lgUp>
          <NavbarMobileToggleFab />
        </Hidden>
      )}
    </>
  );
}

export default React.memo(NavbarWrapperLayout1);
